import { render, staticRenderFns } from "./DashboardModuleLayout.vue?vue&type=template&id=5ef02baa&"
import script from "./DashboardModuleLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardModuleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports